<ng-container *ngrxLet="{user: selectUser$, stateUser: selectStateUser$ } as data">
  @defer (when (sigLoadingData())) {
    <div [formGroup]="formGroup">
      <div class="info" style="margin-bottom: 10px">
        <img [src]="baseHref + '/assets/img/main/ampoule.svg'" class="picto">
        <div class="definition">
          <label class="astuceDef" style="font-weight: 600;color: rgb(53, 166, 217)">
            Pourquoi Groupama vous demande ces informations&nbsp;?
          </label>
          <br />
          <span style="color: black;">
                  Vos données personnelles sont nécessaires au traitement personnalisé de votre Bilan Prévoyance.
                  Elles permettront de vous proposer les solutions de prévoyance les plus adaptées à votre profil.
                  Ces informations ne seront pas communiquées à d’autres organismes à des fins commerciales.<br>
                  Pour plus de précisions et retrouver les informations relatives aux traitements mis en œuvre et aux
                  modalités d'exercice de vos droits, merci de consulter la rubrique "données personnelles" sur
                  <a target='_blank' class="source" href="https://www.groupama.fr">Groupama.fr</a>.
                  @if (isOAV) {
                    <br><b>Si une ou plusieurs des informations ci-dessous sont inexactes, merci de mettre à jour la fiche client dans NEO</b>
                  }
            </span>
          <br />
        </div>
      </div>

      <!-- ========================================================================== -->
      <!-- BY IDGRC -->
      <!-- ========================================================================== -->
      @if (sigByIdgrc()) {
        <div class="row">
          <div class="col-md-6" style="position: relative;margin-bottom: 19px;">
            <app-header-step-idgrc></app-header-step-idgrc>
          </div>
        </div>
      } @else {

        <!-- ========================================================================== -->
          <!-- OAV OR SELF-CARE -->
          <!-- ========================================================================== -->
          <!-- CIVILITE -->
        <div class="row" style="position: relative">
          <div class="col-md-6">
            <app-switch formControlName="civilite"
                        [disabledButton]="sigDisableButtonCivilite()"
                        rightTitle="Monsieur" leftTitle="Madame"
                        [ngClass]="{error: (formGroup | ClassErrorPipe : 'civilite')}"></app-switch>
            <app-errors-messages style="margin-left: 12px;" class="message-normal"
                                 [control]="formGroup.get('civilite')"></app-errors-messages>
          </div>
        </div>
        <!-- NOM -->
        <div class="row">
          <div class="col-md-6" style="position: relative">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Votre nom</mat-label>
              <input [errorStateMatcher]="matcher" matInput placeholder="nom" formControlName="nom" required
                     [readonly]="formGroup.get('byIdgrc').value">
              @if (formGroup.get('nom').invalid && formGroup.get('nom').touched) {
                <mat-error style="display: flex">
                  La saisie de votre nom est obligatoire
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <!-- PRENOM -->
        <div class="row">
          <div class="col-md-6" style="position: relative">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Votre prénom</mat-label>
              <input [errorStateMatcher]="matcher" matInput placeholder="prenom" formControlName="prenom" required
                     [readonly]="formGroup.get('byIdgrc').value">
              @if (formGroup.get('prenom').invalid && formGroup.get('prenom').touched) {
                <mat-error style="display: flex">
                  La saisie de votre prénom est obligatoire
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <!-- DATE NAISSANCE -->
        <div class="row">
          <div class="col-md-6">
            <mat-form-field style="width: 100%" appearance="outline">
              <mat-label>Votre date de naissance</mat-label>
              <input matInput formControlName="dateDeNaissance" [matDatepicker]="pickerDate" [max]="maxDate"
                     autocomplete="off">
              <mat-icon (click)="pickerDate.open()" style="cursor:pointer; color:#777;" matSuffix>today</mat-icon>
              <mat-datepicker #pickerDate startView="multi-year"></mat-datepicker>
              @if (formGroup.get('dateDeNaissance').invalid && formGroup.get('dateDeNaissance').touched) {
                <mat-error style="display: flex">
                  Vous devez saisir une date de naissance correcte
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <!-- CODE POSTAL -->
        <div class="row">
          <div class="col-md-6" style="position: relative">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Votre code postal</mat-label>
              <input [errorStateMatcher]="matcher" matInput placeholder="Code postal" formControlName="codepostal"
                     mask="00000" required>
              @if (formGroup.get('codepostal').invalid && formGroup.get('codepostal').touched) {
                <mat-error style="display: flex">
                  Vous devez saisir votre code postal
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <!-- VILLE -->
        @if (!(queryParams | CheckOAVPipe) && (sigVilles() | ArrayNotNullPipe)) {
          <div class="row">
            <div class="col-md-6" style="position: relative">
              <mat-form-field appearance="outline" class="field">
                <mat-label>Ville</mat-label>
                <mat-select [errorStateMatcher]="matcher" matInput placeholder="Ville" formControlName="ville" required>
                  @for (ville of sigVilles(); track ville.codeInsee) {
                    <mat-option [value]="ville">{{ ville.localite }}{{ ville.lieuDit ? (", " + ville.lieuDit) : "" }}
                    </mat-option>
                  }
                </mat-select>
                @if (formGroup.get('ville').invalid && formGroup.get('ville').touched) {
                  <mat-error style="display: flex">
                    Veuillez sélectionner une ville
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        }
        @if (!(queryParams | CheckOAVPipe) && !!formGroup.get('ville').value) {
          <div class="row">
            <div class="col-md-6" style="position: relative">
              <mat-form-field appearance="outline" class="field">
                <mat-label>Adresse</mat-label>
                <input type="text" placeholder="Choisissez l'adresse" matInput formControlName="adresse" required
                       [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayAdresse">
                  @for (adresse of sigAdresses(); track adresse.idLocalite; let j = $index) {
                    <mat-option [value]="adresse">
                      {{ adresse.numero }} {{ adresse.voie }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (formGroup.get('adresse').invalid && formGroup.get('adresse').touched) {
                  <mat-error style="display: flex">
                    Veuillez sélectionner une Adresse existante
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        }

        <!-- ######################################################v OAV ##################################### -->
        <ng-container *ngrxLet="(queryParams | CheckOAVPipe) as query">
          @if (!!query) {
            <div class="row">
              <div class="col-md-6" style="position: relative">
                <mat-form-field appearance="outline" class="field">
                  <mat-label>Votre email</mat-label>
                  <input [errorStateMatcher]="matcher" matInput placeholder="email" formControlName="email">
                  @if (formGroup.get('email').invalid && formGroup.get('email').touched) {
                    <mat-error style="display: flex">
                      Saisir de votre email obligatoire ou incorrecte
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
        </ng-container>
      }

      @if ((formGroup.value['dateDeNaissance'] | showInfoPipe) !== 'ALERT_INFOS') {
        <div class="row">
          <div class="col-md-6">
            <app-autocomplete-search [data$]="professions$"
                                     label="Choix parmi une liste déroulante "
                                     [defaultValue]="formGroup.get('profession').value"
                                     (onSelection)="updateProfession($event)"
                                     formControlName="profession"
                                     [placeholder]="placeHolderProfession"></app-autocomplete-search>
            @if (formGroup.get('profession').invalid && formGroup.get('profession').touched) {
              <mat-error style="margin-top: -21px;margin-left: 9px;">
                Vous devez saisir la profession
              </mat-error>
            }
          </div>
        </div>
      }

      @if ((formGroup.value['dateDeNaissance'] | showInfoPipe) === 'SHOW_INFO') {
        <div class="row">
          <div class="col-md-6 question" style="margin-top: 0.25em;margin-bottom: 0.25em;">
            <span class="title">Avez-vous un ou des enfant(s) ? <sup>*</sup></span>
            <app-switch formControlName="enfant" rightTitle="Oui" leftTitle="Non"
                        [disabledButton]="childDisableAll()"></app-switch>
          </div>
        </div>

        @if (data.user  | CheckControlPipe : 'ENFANTS' : queryParams : data.stateUser) {
          <div class="row">
            <div class="col-md-6" style="margin-top: 0.75em;margin-bottom: 0.25em;">
              @if (!sigByIdgrc()) {
                <app-date-naissance-enfant [dtEnfants]="sigDatesNaissanceEnfants()"
                                           [disabled]="isNotNull(sigByIdgrc())"
                                           (onChange)="onChangeEnfants($event)"></app-date-naissance-enfant>
              }
              @else {
                <app-date-naissance-enfant-disable [dtEnfants]="sigDatesNaissanceEnfants()"></app-date-naissance-enfant-disable>
              }
            </div>
          </div>
        }

        @if (data.user  | CheckControlPipe : 'PETITS_ENFANTS_MOINS_18_ANS' : queryParams : data.stateUser) {
          <div class="row">
            <div class="col-md-6 col-xs-12 question mt-3">
              <span class="title">Avez-vous un/des petit(s)-enfant(s) de moins de 18 ans ? <sup>*</sup></span>
              <app-switch formControlName="enfantsMoinsDixHuitAns" rightTitle="Oui" leftTitle="Non"
                          [ngClass]="{error: formGroup.get('enfantsMoinsDixHuitAns').value === '' && formGroup.get('enfantsMoinsDixHuitAns').touched}"></app-switch>
              @if (formGroup.get('enfantsMoinsDixHuitAns').value === '' && formGroup.get('enfantsMoinsDixHuitAns').touched) {
                <div class="message-error">
                  Sélection obligatoire si vous avez des petits enfants de moins de 18 ans
                </div>
              }
            </div>
          </div>
        }

        <div class="row">
          <div class="col-md-6 col-xs-12 question mt-3">
            <span class="title">Avez-vous un(e) conjoint(e) ?<sup>*</sup></span>
            <app-switch formControlName="conjoint" rightTitle="Oui" leftTitle="Non"
                        [ngClass]="{error: (formGroup | ClassErrorPipe : 'conjoint') && formGroup.get('conjoint').touched}"></app-switch>
            <app-errors-messages style="margin-left: 12px;" [control]="formGroup.get('conjoint')"></app-errors-messages>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-xs-12">
            @if (data.user  | CheckControlPipe : 'CONJOINT' : queryParams : data.stateUser) {
              <div class="expansion-fidelite-client" style="width: 100%;flex-direction: column">
                <div style="display: flex;flex-direction: row;align-items: flex-end;">
                  <div>
                    <mat-icon>person</mat-icon>
                  </div>
                  <div style="margin-left: 10px;margin-bottom: 3px;font-weight: 600;">
                    Offre fidélité
                  </div>
                </div>
                <div style="color: black">
                  Bénéficiez d'une <b>réduction de 10% sur la cotisation du contrat Groupama Sécurité ou Groupama
                  Sérénité
                  Obsèques</b>
                </div>
              </div>
            }
          </div>
        </div>

        @if (data.user  | CheckControlPipe : typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT : queryParams : data.stateUser) {
          <div class="row">
            <div class="col-md-6 question mt-3">
            <span
              class="title">Avez-vous un emprunt immobilier en cours ou un projet d'emprunt&nbsp;? <sup>*</sup></span>
              <app-switch-multiple [formControlName]="typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT"
                                   [titles]="titlesEmprunt"
                                   (onSwitch)="updateProjetEmprunt()"
                                   position="VERTICAL"
                                   [ngClass]="{error: formGroup.get(typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT).value === '' && formGroup.get(typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT).touched}"></app-switch-multiple>
              @if (formGroup.get(typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT).value === '' && formGroup.get(typeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT).touched) {
                <div class="message-error">
                  sélection obligatoire de la détention d'un emprunt
                </div>
              }
            </div>
          </div>
        }

        @if (data.user  | CheckControlPipe : typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE : queryParams : data.stateUser) {
          <div class="row">
            <div class="col-md-6 question mt-3">
            <span
              class="title">Le montant qu’il vous reste à rembourser ou le montant du projet est-il supérieur à <br>15 000 € ?&nbsp;<sup>*</sup></span>
              <app-switch [formControlName]="typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE" rightTitle="Oui"
                          leftTitle="Non"
                          [ngClass]="{error: formGroup.get(typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE).value === '' && formGroup.get(typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE).touched}"></app-switch>
              @if (formGroup.get(typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE).value === '' && formGroup.get(typeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE).touched) {
                <div class="message-error">
                  sélection de l'emprunt immobilier obligatoire
                </div>
              }
            </div>
          </div>
        }

        @if ((data.user  | CheckControlPipe : typeProjetEnum.OBSEQUES : queryParams : data.stateUser)) {
          <div class="row">
            <div class="col-md-6 col-xs-12 question mt-3">
              <span class="title">Êtes-vous détenteur d’une assurance obsèques ? <sup>*</sup></span>
              <app-switch [formControlName]="typeProjetEnum.OBSEQUES" rightTitle="Oui" leftTitle="Non"
                          [ngClass]="{error: formGroup.get(typeProjetEnum.OBSEQUES).value === '' && formGroup.get(typeProjetEnum.OBSEQUES).touched}"></app-switch>
              @if (formGroup.get(typeProjetEnum.OBSEQUES).value === '' && formGroup.get(typeProjetEnum.OBSEQUES).touched) {
                <div class="message-error">
                  Sélection obligatoire de la détention
                </div>
              }
            </div>
          </div>
        }

        @if (data.user  | CheckControlPipe : typeProjetEnum.GAV : queryParams : data.stateUser) {
          <div class="row">
            <div class="col-md-6 question mt-3">
              <div class="title">Êtes-vous détenteur d’une assurance Garantie des Accidents de la Vie&nbsp;?<sup>*</sup>
                <button mat-icon-button
                        [matTooltip]="tooptip"
                        matTooltipPosition="after">
                  <img style="width: 26px;" [src]="baseHref + '/assets/img/boutons/info.svg'">
                </button>
              </div>
              <app-switch formControlName="GAV" rightTitle="Oui" leftTitle="Non"
                          [ngClass]="{error: formGroup.get(typeProjetEnum.GAV).value === '' && formGroup.get(typeProjetEnum.GAV).touched}"></app-switch>
              @if (formGroup.get(typeProjetEnum.GAV).value === '' && formGroup.get(typeProjetEnum.GAV).touched) {
                <div class="message-error">sélection obligatoire de l'accident de la vie</div>
              }
            </div>
          </div>
        }
      }
      @if ((formGroup.value['dateDeNaissance'] | showInfoPipe) === 'ALERT_INFOS') {
        <h4 style="font-size: 18px;padding: 14px;">
          Le bilan prévoyance est accessible aux majeurs de moins de 85 ans.
        </h4>
      }
    </div>
  } @placeholder () {
    <loader width="200" style="display: flex;justify-content: center"></loader>
  }
</ng-container>
